import * as React from "react";
import type { SVGProps } from "react";

interface MainProps extends SVGProps<SVGSVGElement> {
  cancelled?: boolean;
}
const Main = ({ cancelled = false, ...props }: MainProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={66}
    height={66}
    viewBox="0 0 66 66"
    {...props}
  >
    <g>
    <g fill="none" fillRule="evenodd" transform="translate(6.875 6.875)">
      <g>
        <ellipse
          cx={26.217}
          cy={26.125}
          fill="#EFDFBF"
          stroke="#FFF"
          strokeWidth={8.877}
          rx={26.448}
          ry={26.439}
        />
        <ellipse
          cx={26.217}
          cy={26.125}
          stroke="#000"
          strokeWidth={7}
          rx={25.51}
          ry={25.5}
        />
        <ellipse
          cx={26.217}
          cy={26.125}
          stroke="#3B3B3B"
          strokeWidth={5.729}
          rx={24.874}
          ry={24.864}
        />
      </g>
      <path
        fill="#3B3B3B"
        d="m30.248 0-3.746 24.951L38.139 2.564l6.677 4.851-17.691 17.982 22.568-11.27 2.55 7.85-24.883 4.148 24.883 4.148-2.55 7.85-22.569-11.27 17.692 17.982-6.677 4.851-11.636-22.382 3.745 24.946h-8.253l3.741-24.941-11.632 22.377-6.677-4.851L25.12 26.852 2.55 38.122 0 30.274l24.882-4.148L0 21.977l2.55-7.85 22.568 11.27L7.428 7.415l6.676-4.851 11.632 22.38L21.995 0z"
      />
      <circle cx={26.125} cy={26.125} r={2.063} fill="#60B100" />
      <circle cx={26.125} cy={26.125} r={1.031} fill="#FF1212" />
    </g>
        {cancelled && (
        <rect
          width="25"
          height="2.5"
          x="-.494"
          y="10.746"
          fill="#000"
          fillRule="evenodd"
          stroke="#FFF"
          rx="1"
          transform="rotate(-45 12.006 11.996)"
        />
      )}
    </g>
  </svg>
);
export default Main;
